var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureChatUploadMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.938,
    height: 16.133,
    viewBox: "0 0 13.938 16.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-lock-02-svgrepo-com",
    d: "M15.706,7.853V5.512A5.453,5.453,0,0,0,15.467,3.2a2.195,2.195,0,0,0-.959-.959A5.453,5.453,0,0,0,12.194,2H7.512A5.453,5.453,0,0,0,5.2,2.239a2.195,2.195,0,0,0-.959.959A5.453,5.453,0,0,0,4,5.512v7.609a5.453,5.453,0,0,0,.239,2.313,2.195,2.195,0,0,0,.959.959,5.453,5.453,0,0,0,2.313.239H8.756m1.829-8.048H6.927m2.195,2.927H6.927M12.78,5.658H6.927m8.231,7.316v-1.28a1.28,1.28,0,0,0-2.561,0v1.28m-.11,2.927h2.78a1.818,1.818,0,0,0,.771-.08.732.732,0,0,0,.32-.32,1.818,1.818,0,0,0,.08-.771v-.585a1.818,1.818,0,0,0-.08-.771.732.732,0,0,0-.32-.32,1.818,1.818,0,0,0-.771-.08h-2.78a1.818,1.818,0,0,0-.771.08.732.732,0,0,0-.32.32,1.818,1.818,0,0,0-.08.771v.585a1.818,1.818,0,0,0,.08.771.732.732,0,0,0,.32.32A1.818,1.818,0,0,0,12.487,15.9Z",
    transform: "translate(-3.25 -1.25)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureChatUploadMediaIcon);
export default __webpack_public_path__ + "static/media/secure-chat-upload-media-icon.4ccc3951387244ea17c8bf9eb517efbb.svg";
export { ForwardRef as ReactComponent };